import {memo} from 'preact/compat';
import Icon from '@components/common/Icon';
import {Checkbox, Show, ToggleSwitch} from '@ultradent/components';
import {Form, Formik} from 'formik';
import PropTypes from 'prop-types';
import {notEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

const LocationCard = memo( ( {
                                 address,
                                 productOfferings,
                                 displayOnMap,
                                 onUpdateProductOffering,
                                 onUpdateDisplayOnMap
                             } ) => {

    console.log( 'LocationCard', address );
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                productOfferings: productOfferings.filter( ( {offered} ) => offered ).map( ( {id} ) => id ),
                displayOnMap: [displayOnMap ? 'yes' : 'no']
            }}>
            <Form>
                <section
                    data-testid="location-card"
                    className="bg-white max-w-5xl w-full mx-auto flex flex-col relative border-2 border-solid border-grey-lightest my-4">
                        <div className="flex flex-col lg:flex-row h-full">
                            <div className="lg:w-1/3 flex flex-col justify-center">
                                <div className="bg-grey-lightest w-full py-2 px-4">
                                    <h2>Show on map</h2>
                                </div>
                                <div
                                    className="flex flex-col items-center justify-center my-auto py-2">
                                    <Icon.ui name="location-marker" className="text-3xl text-brand mb-3"/>
                                    <ToggleSwitch
                                        data-testid="display-on-map-toggle"
                                        label={null}
                                        name="displayOnMap"
                                        value="yes"
                                        onChange={value => onUpdateDisplayOnMap( {
                                            addressId: address.id,
                                            displayOnMap: value
                                        } )}
                                    />
                                </div>
                            </div>

                            <div
                                className="lg:w-1/3 lg:border-l-2 lg:border-r-2 border-solid border-grey-lightest flex flex-col justify-center">
                                <div className="bg-grey-lightest w-full py-2 px-4">
                                    <h2>Location</h2>
                                </div>
                                <div
                                    className="leading-normal text-body flex flex-col justify-center py-2 px-4 my-auto">
                                    <p>{address.addressName}</p>
                                    <p className="my-2">
                                        {address.address1}
                                        <Show when={notEmptyOrNil( address.address2 )}>
                                            {' ' + address.address2}
                                        </Show>
                                        ,
                                        <span className="block leading-none mb-1">
                                            {address.city}, {address.state} {address.postalCode}
                                        </span>
                                    </p>
                                    <Show when={notEmptyOrNil( address.phoneNumber )}>
                                        <p>{address.phoneNumber}</p>
                                    </Show>
                                </div>
                            </div>

                            <div className="lg:w-1/3 border-t-2 lg:border-none flex flex-col">
                                <div className="bg-grey-lightest w-full py-2 px-4">
                                    <h2>Product Offering</h2>
                                </div>
                                <div className="py-2 px-4 my-auto">
                                    <ul className="list-reset">
                                        <li className="clear flex flex-col">
                                        {productOfferings.map(
                                            item =>
                                                <Checkbox
                                                    name="productOfferings"
                                                    label={item.title}
                                                    id={item.id}
                                                    value={item.id}
                                                    recede={!item.available}
                                                    tooltip={!item.available && '*No purchase history of product'}
                                                    onChange={value => onUpdateProductOffering( {
                                                        addressId: address.id,
                                                        productOfferingId: item.id,
                                                        offered: value
                                                    } )}
                                                />
                                        )}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                </section>
            </Form>
        </Formik>
    )
} );

LocationCard.propTypes = {
    address: PropTypes.shape( {
        id: PropTypes.number,
        addressName: PropTypes.string,
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        postalCode: PropTypes.string
    } ),
    productOfferings: PropTypes.arrayOf( PropTypes.shape( {
        id: PropTypes.number,
        title: PropTypes.string,
        available: PropTypes.bool
    } ) ),
    displayOnMap: PropTypes.bool,
    onUpdateProductOffering: PropTypes.func,
    onUpdateDisplayOnMap: PropTypes.func
};

export default LocationCard;
